var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTables(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_450_1717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.782 8.59748H18.0958C17.7308 7.35645 16.7964 6.46582 15.6867 6.33442C15.7305 6.27602 15.7597 6.20301 15.7597 6.11541C15.7597 5.92561 15.5991 5.7796 15.4239 5.7796C15.2341 5.7796 15.0881 5.94021 15.0881 6.11541C15.0881 6.18841 15.1173 6.27602 15.1611 6.33442C14.0223 6.46582 13.0878 7.37105 12.7082 8.59748H12.1096V9.1669H18.782V8.59748Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.001 9.75092H7.77332V10.5685H19.001V9.75092Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72944 4.33419C8.72127 4.33419 9.52529 3.53016 9.52529 2.53834C9.52529 1.54652 8.72127 0.742493 7.72944 0.742493C6.73762 0.742493 5.93359 1.54652 5.93359 2.53834C5.93359 3.53016 6.73762 4.33419 7.72944 4.33419Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56908 11.0358H6.54679V8.78729L4.98455 6.11542C4.92615 6.01321 4.96995 5.86721 5.05755 5.80881C5.15975 5.75041 5.30576 5.79421 5.36416 5.88181L7.16001 8.9771C7.29141 9.2107 7.53962 9.37131 7.83163 9.37131H10.9269C11.3649 9.37131 11.7153 9.0063 11.7153 8.58288C11.7153 8.14487 11.3503 7.79446 10.9269 7.79446L8.34264 7.82366L6.28399 4.34877C6.13798 4.07136 5.83137 3.92535 5.46636 3.92535C5.42256 3.92535 5.30576 3.93995 5.24736 3.95455C5.20356 3.96916 5.13055 3.98376 5.08675 3.99836C3.56831 4.49477 2.37108 6.88924 2.37108 9.35671C2.35648 10.1013 2.37108 10.7291 2.41488 11.3278C2.35648 12.0432 2.77989 12.744 3.48071 13.0068C3.67051 13.0652 3.84572 13.109 4.03552 13.109H8.54705V17.3285C8.54705 17.9125 8.99966 18.3506 9.56908 18.3506C10.1531 18.3506 10.5911 17.8979 10.5911 17.3285V12.0724C10.5911 11.8096 10.4889 11.5322 10.2845 11.357C10.0801 11.1526 9.81728 11.0358 9.56908 11.0358Z",
    fill: "#E5E5E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_450_1717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6885,
    height: 18.6885,
    fill: "white",
    transform: "translate(0.765015 0.377441)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTables);
export default __webpack_public_path__ + "static/media/tables.a86850958093fd89fe39226818037a2c.svg";
export { ForwardRef as ReactComponent };